/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Aria_LabelInputs */

const fr_about_aria_label = /** @type {(inputs: About_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const en_about_aria_label = /** @type {(inputs: About_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {About_Aria_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_aria_label = /** @type {((inputs?: About_Aria_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Aria_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_aria_label(inputs)
	return en_about_aria_label(inputs)
});